// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file account_service.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Achievement } from "./achievements_pb";
import { file_achievements } from "./achievements_pb";
import type { AuthenticatorBlock, AuthenticatorCreationData } from "./authenticator_pb";
import { file_authenticator } from "./authenticator_pb";
import type { Token } from "./credential_service_pb";
import { file_credential_service } from "./credential_service_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { OrganizationType } from "./organization_type_pb";
import { file_organization_type } from "./organization_type_pb";
import type { ProfileData } from "./profile_pb";
import { file_profile } from "./profile_pb";
import type { ProfileType } from "./profile_type_pb";
import { file_profile_type } from "./profile_type_pb";
import type { RegistrationInfoStatus } from "./registration_info_status_pb";
import { file_registration_info_status } from "./registration_info_status_pb";
import type { SyncUpdate } from "./sync_update_pb";
import { file_sync_update } from "./sync_update_pb";
import type { VaultCreationData } from "./vault_service_pb";
import { file_vault_service } from "./vault_service_pb";
import type { WebauthnPrfSupportStatus } from "./webauthn_prf_support_status_pb";
import { file_webauthn_prf_support_status } from "./webauthn_prf_support_status_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file account_service.proto.
 */
export const file_account_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_achievements, file_authenticator, file_credential_service, file_google_protobuf_timestamp, file_google_protobuf_wrappers, file_organization_type, file_profile, file_profile_type, file_registration_info_status, file_sync_update, file_vault_service, file_webauthn_prf_support_status]);

/**
 * @generated from message domain.GetRegistrationInfoRequest
 */
export type GetRegistrationInfoRequest = Message<"domain.GetRegistrationInfoRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * May be provided as an alternative to email
   *
   * @generated from field: string profile_id = 2;
   */
  profileId: string;
};

/**
 * Describes the message domain.GetRegistrationInfoRequest.
 * Use `create(GetRegistrationInfoRequestSchema)` to create a new message.
 */
export const GetRegistrationInfoRequestSchema: GenMessage<GetRegistrationInfoRequest> = /*@__PURE__*/
  messageDesc(file_account_service, 0);

/**
 * @generated from message domain.GetRegistrationInfoResponse
 */
export type GetRegistrationInfoResponse = Message<"domain.GetRegistrationInfoResponse"> & {
  /**
   * @generated from field: domain.RegistrationInfoStatus status = 1;
   */
  status: RegistrationInfoStatus;

  /**
   * @generated from field: domain.GetRegistrationInfoResponse.Organization organization = 2;
   */
  organization?: GetRegistrationInfoResponse_Organization | undefined;

  /**
   * @generated from field: bool webauthn_allowed = 3;
   */
  webauthnAllowed: boolean;

  /**
   * @generated from field: domain.ProfileType profile_type = 7;
   */
  profileType: ProfileType;
};

/**
 * Describes the message domain.GetRegistrationInfoResponse.
 * Use `create(GetRegistrationInfoResponseSchema)` to create a new message.
 */
export const GetRegistrationInfoResponseSchema: GenMessage<GetRegistrationInfoResponse> = /*@__PURE__*/
  messageDesc(file_account_service, 1);

/**
 * @generated from message domain.GetRegistrationInfoResponse.Organization
 */
export type GetRegistrationInfoResponse_Organization = Message<"domain.GetRegistrationInfoResponse.Organization"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string icon = 2;
   */
  icon: string;

  /**
   * @generated from field: string id = 3;
   */
  id: string;

  /**
   * @generated from field: string profile_id = 4;
   */
  profileId: string;

  /**
   * @generated from field: string start_code_prefix = 5;
   */
  startCodePrefix: string;

  /**
   * @generated from field: domain.OrganizationType organization_type = 6;
   */
  organizationType: OrganizationType;
};

/**
 * Describes the message domain.GetRegistrationInfoResponse.Organization.
 * Use `create(GetRegistrationInfoResponse_OrganizationSchema)` to create a new message.
 */
export const GetRegistrationInfoResponse_OrganizationSchema: GenMessage<GetRegistrationInfoResponse_Organization> = /*@__PURE__*/
  messageDesc(file_account_service, 1, 0);

/**
 * @generated from message domain.CreateAccountWithProfileRequest
 */
export type CreateAccountWithProfileRequest = Message<"domain.CreateAccountWithProfileRequest"> & {
  /**
   * Backend will attach the first authenticator in this list as the pairing authenticator to the created session
   * This is typically a PUSH or DUMMY authenticator.
   *
   * @generated from field: repeated domain.AuthenticatorCreationData authenticators = 14;
   */
  authenticators: AuthenticatorCreationData[];

  /**
   * @generated from field: domain.ProfileData preferences_profile = 2;
   */
  preferencesProfile?: ProfileData | undefined;

  /**
   * @generated from field: domain.ProfileData inbox_profile = 3;
   */
  inboxProfile?: ProfileData | undefined;

  /**
   * @generated from field: domain.VaultCreationData meta_vault = 4;
   */
  metaVault?: VaultCreationData | undefined;

  /**
   * @generated from field: string referrer_id = 5;
   */
  referrerId: string;

  /**
   * @generated from field: bytes authenticator_block = 6;
   */
  authenticatorBlock: Uint8Array;

  /**
   * @generated from field: bytes authenticator_block_signature = 7;
   */
  authenticatorBlockSignature: Uint8Array;

  /**
   * @generated from field: string preliminary_email = 10;
   */
  preliminaryEmail: string;

  /**
   * @generated from field: string start_code = 13;
   */
  startCode: string;

  /**
   * if supplied, unlocks initial session. required if first authenticator is of type session unlock
   *
   * @generated from field: domain.CreateAccountWithProfileRequest.SessionUnlockData session_unlock_data = 15;
   */
  sessionUnlockData?: CreateAccountWithProfileRequest_SessionUnlockData | undefined;

  /**
   * if supplied, establishes an webauthn credential. required if first authenticator is type session unlock
   *
   * @generated from field: domain.CreateAccountWithProfileRequest.WebauthnCredentialData webauthn_credential_data = 16;
   */
  webauthnCredentialData?: CreateAccountWithProfileRequest_WebauthnCredentialData | undefined;

  /**
   * when minimumClientVersion > 2023-12-XX, then this is mandatory when supplying a start_code
   *
   * @generated from field: string start_code_profile_id = 17;
   */
  startCodeProfileId: string;

  /**
   * Read from device management by connected clients, see organizations.browser_managed_device_token.
   *
   * @generated from field: string browser_managed_device_token = 18;
   */
  browserManagedDeviceToken: string;
};

/**
 * Describes the message domain.CreateAccountWithProfileRequest.
 * Use `create(CreateAccountWithProfileRequestSchema)` to create a new message.
 */
export const CreateAccountWithProfileRequestSchema: GenMessage<CreateAccountWithProfileRequest> = /*@__PURE__*/
  messageDesc(file_account_service, 2);

/**
 * @generated from message domain.CreateAccountWithProfileRequest.WebauthnCredentialData
 */
export type CreateAccountWithProfileRequest_WebauthnCredentialData = Message<"domain.CreateAccountWithProfileRequest.WebauthnCredentialData"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: string response_json = 2;
   */
  responseJson: string;

  /**
   * @generated from field: domain.WebauthnPrfSupportStatus prf_support_status = 3;
   */
  prfSupportStatus: WebauthnPrfSupportStatus;
};

/**
 * Describes the message domain.CreateAccountWithProfileRequest.WebauthnCredentialData.
 * Use `create(CreateAccountWithProfileRequest_WebauthnCredentialDataSchema)` to create a new message.
 */
export const CreateAccountWithProfileRequest_WebauthnCredentialDataSchema: GenMessage<CreateAccountWithProfileRequest_WebauthnCredentialData> = /*@__PURE__*/
  messageDesc(file_account_service, 2, 0);

/**
 * @generated from message domain.CreateAccountWithProfileRequest.SessionUnlockData
 */
export type CreateAccountWithProfileRequest_SessionUnlockData = Message<"domain.CreateAccountWithProfileRequest.SessionUnlockData"> & {
  /**
   * @generated from field: bytes encrypted_secret = 1;
   */
  encryptedSecret: Uint8Array;

  /**
   * @generated from field: google.protobuf.Timestamp unlock_max_expires_at = 2;
   */
  unlockMaxExpiresAt?: Timestamp | undefined;
};

/**
 * Describes the message domain.CreateAccountWithProfileRequest.SessionUnlockData.
 * Use `create(CreateAccountWithProfileRequest_SessionUnlockDataSchema)` to create a new message.
 */
export const CreateAccountWithProfileRequest_SessionUnlockDataSchema: GenMessage<CreateAccountWithProfileRequest_SessionUnlockData> = /*@__PURE__*/
  messageDesc(file_account_service, 2, 1);

/**
 * @generated from message domain.CreateAccountWithProfileResponse
 */
export type CreateAccountWithProfileResponse = Message<"domain.CreateAccountWithProfileResponse"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: domain.Token access_token = 2;
   */
  accessToken?: Token | undefined;

  /**
   * @generated from field: string session_id = 3;
   */
  sessionId: string;

  /**
   * @generated from field: repeated string authenticator_ids = 4;
   */
  authenticatorIds: string[];

  /**
   * @generated from field: string preferences_profile_id = 5;
   */
  preferencesProfileId: string;

  /**
   * @generated from field: string meta_vault_id = 7;
   */
  metaVaultId: string;

  /**
   * @generated from field: string inbox_profile_id = 6;
   */
  inboxProfileId: string;

  /**
   * @generated from field: int32 token_version = 8;
   */
  tokenVersion: number;
};

/**
 * Describes the message domain.CreateAccountWithProfileResponse.
 * Use `create(CreateAccountWithProfileResponseSchema)` to create a new message.
 */
export const CreateAccountWithProfileResponseSchema: GenMessage<CreateAccountWithProfileResponse> = /*@__PURE__*/
  messageDesc(file_account_service, 3);

/**
 * no change if null
 *
 * @generated from message domain.UpdateAccountRequest
 */
export type UpdateAccountRequest = Message<"domain.UpdateAccountRequest"> & {
  /**
   * @generated from field: google.protobuf.StringValue preferred_locale = 2;
   */
  preferredLocale?: string | undefined;

  /**
   * @generated from field: google.protobuf.StringValue user_client_settings = 3;
   */
  userClientSettings?: string | undefined;

  /**
   * @generated from field: google.protobuf.BoolValue profiles_locked = 4;
   */
  profilesLocked?: boolean | undefined;
};

/**
 * Describes the message domain.UpdateAccountRequest.
 * Use `create(UpdateAccountRequestSchema)` to create a new message.
 */
export const UpdateAccountRequestSchema: GenMessage<UpdateAccountRequest> = /*@__PURE__*/
  messageDesc(file_account_service, 4);

/**
 * @generated from message domain.UpdateAccountResponse
 */
export type UpdateAccountResponse = Message<"domain.UpdateAccountResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.UpdateAccountResponse.
 * Use `create(UpdateAccountResponseSchema)` to create a new message.
 */
export const UpdateAccountResponseSchema: GenMessage<UpdateAccountResponse> = /*@__PURE__*/
  messageDesc(file_account_service, 5);

/**
 * @generated from message domain.CreateReferrerRequest
 */
export type CreateReferrerRequest = Message<"domain.CreateReferrerRequest"> & {
  /**
   * @generated from field: string referrer = 1;
   */
  referrer: string;
};

/**
 * Describes the message domain.CreateReferrerRequest.
 * Use `create(CreateReferrerRequestSchema)` to create a new message.
 */
export const CreateReferrerRequestSchema: GenMessage<CreateReferrerRequest> = /*@__PURE__*/
  messageDesc(file_account_service, 6);

/**
 * @generated from message domain.CreateReferrerResponse
 */
export type CreateReferrerResponse = Message<"domain.CreateReferrerResponse"> & {
  /**
   * @generated from field: string referrer_id = 1;
   */
  referrerId: string;
};

/**
 * Describes the message domain.CreateReferrerResponse.
 * Use `create(CreateReferrerResponseSchema)` to create a new message.
 */
export const CreateReferrerResponseSchema: GenMessage<CreateReferrerResponse> = /*@__PURE__*/
  messageDesc(file_account_service, 7);

/**
 * @generated from message domain.AddAchievementsRequest
 */
export type AddAchievementsRequest = Message<"domain.AddAchievementsRequest"> & {
  /**
   * @generated from field: repeated domain.Achievement achievements = 1;
   */
  achievements: Achievement[];
};

/**
 * Describes the message domain.AddAchievementsRequest.
 * Use `create(AddAchievementsRequestSchema)` to create a new message.
 */
export const AddAchievementsRequestSchema: GenMessage<AddAchievementsRequest> = /*@__PURE__*/
  messageDesc(file_account_service, 8);

/**
 * @generated from message domain.AddAchievementsResponse
 */
export type AddAchievementsResponse = Message<"domain.AddAchievementsResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.AddAchievementsResponse.
 * Use `create(AddAchievementsResponseSchema)` to create a new message.
 */
export const AddAchievementsResponseSchema: GenMessage<AddAchievementsResponse> = /*@__PURE__*/
  messageDesc(file_account_service, 9);

/**
 * @generated from message domain.ListAccountsRequest
 */
export type ListAccountsRequest = Message<"domain.ListAccountsRequest"> & {
  /**
   * @generated from field: repeated domain.ListAccountsRequest.User users = 1;
   */
  users: ListAccountsRequest_User[];

  /**
   * @generated from field: repeated string emails = 2;
   */
  emails: string[];

  /**
   * @generated from field: repeated string profile_ids = 3;
   */
  profileIds: string[];
};

/**
 * Describes the message domain.ListAccountsRequest.
 * Use `create(ListAccountsRequestSchema)` to create a new message.
 */
export const ListAccountsRequestSchema: GenMessage<ListAccountsRequest> = /*@__PURE__*/
  messageDesc(file_account_service, 10);

/**
 * @generated from message domain.ListAccountsRequest.User
 */
export type ListAccountsRequest_User = Message<"domain.ListAccountsRequest.User"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: bytes authenticator_block_hash = 2;
   */
  authenticatorBlockHash: Uint8Array;
};

/**
 * Describes the message domain.ListAccountsRequest.User.
 * Use `create(ListAccountsRequest_UserSchema)` to create a new message.
 */
export const ListAccountsRequest_UserSchema: GenMessage<ListAccountsRequest_User> = /*@__PURE__*/
  messageDesc(file_account_service, 10, 0);

/**
 * @generated from message domain.ListAccountsResponse
 */
export type ListAccountsResponse = Message<"domain.ListAccountsResponse"> & {
  /**
   * @generated from field: repeated domain.ListAccountsResponse.User users = 1;
   */
  users: ListAccountsResponse_User[];
};

/**
 * Describes the message domain.ListAccountsResponse.
 * Use `create(ListAccountsResponseSchema)` to create a new message.
 */
export const ListAccountsResponseSchema: GenMessage<ListAccountsResponse> = /*@__PURE__*/
  messageDesc(file_account_service, 11);

/**
 * @generated from message domain.ListAccountsResponse.User
 */
export type ListAccountsResponse_User = Message<"domain.ListAccountsResponse.User"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * email is only set for users requested by email
   *
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: repeated domain.ListAccountsResponse.User.ForeignAuthenticator authenticators = 3;
   */
  authenticators: ListAccountsResponse_User_ForeignAuthenticator[];

  /**
   * @generated from field: repeated domain.AuthenticatorBlock authenticator_blocks = 4;
   */
  authenticatorBlocks: AuthenticatorBlock[];
};

/**
 * Describes the message domain.ListAccountsResponse.User.
 * Use `create(ListAccountsResponse_UserSchema)` to create a new message.
 */
export const ListAccountsResponse_UserSchema: GenMessage<ListAccountsResponse_User> = /*@__PURE__*/
  messageDesc(file_account_service, 11, 0);

/**
 * @generated from message domain.ListAccountsResponse.User.ForeignAuthenticator
 */
export type ListAccountsResponse_User_ForeignAuthenticator = Message<"domain.ListAccountsResponse.User.ForeignAuthenticator"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: bytes high_security_identity_sig_pub_key = 3;
   */
  highSecurityIdentitySigPubKey: Uint8Array;

  /**
   * @generated from field: bytes high_security_profile_seed_enc_pub_key = 4;
   */
  highSecurityProfileSeedEncPubKey: Uint8Array;

  /**
   * @generated from field: bytes high_security_profile_seed_enc_pub_key_signature = 5;
   */
  highSecurityProfileSeedEncPubKeySignature: Uint8Array;

  /**
   * @generated from field: bytes storable_sig_pub_key = 6;
   */
  storableSigPubKey: Uint8Array;

  /**
   * @generated from field: bytes storable_sig_pub_key_signature = 7;
   */
  storableSigPubKeySignature: Uint8Array;

  /**
   * @generated from field: bytes storable_profile_seed_enc_pub_key = 8;
   */
  storableProfileSeedEncPubKey: Uint8Array;

  /**
   * @generated from field: bytes storable_profile_seed_enc_pub_key_signature = 9;
   */
  storableProfileSeedEncPubKeySignature: Uint8Array;
};

/**
 * Describes the message domain.ListAccountsResponse.User.ForeignAuthenticator.
 * Use `create(ListAccountsResponse_User_ForeignAuthenticatorSchema)` to create a new message.
 */
export const ListAccountsResponse_User_ForeignAuthenticatorSchema: GenMessage<ListAccountsResponse_User_ForeignAuthenticator> = /*@__PURE__*/
  messageDesc(file_account_service, 11, 0, 0);

/**
 * @generated from message domain.ResolveEmailsRequest
 */
export type ResolveEmailsRequest = Message<"domain.ResolveEmailsRequest"> & {
  /**
   * @generated from field: repeated string emails = 1;
   */
  emails: string[];

  /**
   * @generated from field: bool fail_fast = 2;
   */
  failFast: boolean;
};

/**
 * Describes the message domain.ResolveEmailsRequest.
 * Use `create(ResolveEmailsRequestSchema)` to create a new message.
 */
export const ResolveEmailsRequestSchema: GenMessage<ResolveEmailsRequest> = /*@__PURE__*/
  messageDesc(file_account_service, 12);

/**
 * @generated from message domain.ResolveEmailsResponse
 */
export type ResolveEmailsResponse = Message<"domain.ResolveEmailsResponse"> & {
  /**
   * @generated from field: repeated domain.ResolveEmailsResponse.ResolvedEmail emails = 1;
   */
  emails: ResolveEmailsResponse_ResolvedEmail[];
};

/**
 * Describes the message domain.ResolveEmailsResponse.
 * Use `create(ResolveEmailsResponseSchema)` to create a new message.
 */
export const ResolveEmailsResponseSchema: GenMessage<ResolveEmailsResponse> = /*@__PURE__*/
  messageDesc(file_account_service, 13);

/**
 * @generated from message domain.ResolveEmailsResponse.ResolvedProfile
 */
export type ResolveEmailsResponse_ResolvedProfile = Message<"domain.ResolveEmailsResponse.ResolvedProfile"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: domain.ProfileType profile_type = 3;
   */
  profileType: ProfileType;
};

/**
 * Describes the message domain.ResolveEmailsResponse.ResolvedProfile.
 * Use `create(ResolveEmailsResponse_ResolvedProfileSchema)` to create a new message.
 */
export const ResolveEmailsResponse_ResolvedProfileSchema: GenMessage<ResolveEmailsResponse_ResolvedProfile> = /*@__PURE__*/
  messageDesc(file_account_service, 13, 0);

/**
 * @generated from message domain.ResolveEmailsResponse.ResolvedEmail
 */
export type ResolveEmailsResponse_ResolvedEmail = Message<"domain.ResolveEmailsResponse.ResolvedEmail"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: bool email_invalid = 4;
   */
  emailInvalid: boolean;

  /**
   * @generated from field: repeated domain.ResolveEmailsResponse.ResolvedProfile profiles = 2;
   */
  profiles: ResolveEmailsResponse_ResolvedProfile[];

  /**
   * @generated from field: string user_id = 3;
   */
  userId: string;
};

/**
 * Describes the message domain.ResolveEmailsResponse.ResolvedEmail.
 * Use `create(ResolveEmailsResponse_ResolvedEmailSchema)` to create a new message.
 */
export const ResolveEmailsResponse_ResolvedEmailSchema: GenMessage<ResolveEmailsResponse_ResolvedEmail> = /*@__PURE__*/
  messageDesc(file_account_service, 13, 1);

/**
 * @generated from message domain.GetPaddleConfigRequest
 */
export type GetPaddleConfigRequest = Message<"domain.GetPaddleConfigRequest"> & {
};

/**
 * Describes the message domain.GetPaddleConfigRequest.
 * Use `create(GetPaddleConfigRequestSchema)` to create a new message.
 */
export const GetPaddleConfigRequestSchema: GenMessage<GetPaddleConfigRequest> = /*@__PURE__*/
  messageDesc(file_account_service, 14);

/**
 * @generated from message domain.GetPaddleConfigResponse
 */
export type GetPaddleConfigResponse = Message<"domain.GetPaddleConfigResponse"> & {
  /**
   * @generated from field: bool is_sandbox = 1;
   */
  isSandbox: boolean;

  /**
   * @generated from field: string wrapper_host = 2;
   */
  wrapperHost: string;

  /**
   * @generated from field: int64 vendor_id = 3;
   */
  vendorId: bigint;

  /**
   * @generated from field: int64 product_id_monthly = 4;
   */
  productIdMonthly: bigint;

  /**
   * @generated from field: int64 product_id_yearly = 5;
   */
  productIdYearly: bigint;
};

/**
 * Describes the message domain.GetPaddleConfigResponse.
 * Use `create(GetPaddleConfigResponseSchema)` to create a new message.
 */
export const GetPaddleConfigResponseSchema: GenMessage<GetPaddleConfigResponse> = /*@__PURE__*/
  messageDesc(file_account_service, 15);

/**
 * empty
 *
 * @generated from message domain.DeleteAccountRequest
 */
export type DeleteAccountRequest = Message<"domain.DeleteAccountRequest"> & {
};

/**
 * Describes the message domain.DeleteAccountRequest.
 * Use `create(DeleteAccountRequestSchema)` to create a new message.
 */
export const DeleteAccountRequestSchema: GenMessage<DeleteAccountRequest> = /*@__PURE__*/
  messageDesc(file_account_service, 16);

/**
 * empty
 *
 * @generated from message domain.DeleteAccountResponse
 */
export type DeleteAccountResponse = Message<"domain.DeleteAccountResponse"> & {
};

/**
 * Describes the message domain.DeleteAccountResponse.
 * Use `create(DeleteAccountResponseSchema)` to create a new message.
 */
export const DeleteAccountResponseSchema: GenMessage<DeleteAccountResponse> = /*@__PURE__*/
  messageDesc(file_account_service, 17);

/**
 * AccountService provides methods for handling user accounts.
 *
 * @generated from service domain.AccountService
 */
export const AccountService: GenService<{
  /**
   * - InvalidEmail (20101)
   * - BadRequest (10400): both email and profile_id set
   * - ProfileNotFound (70400): profile not found
   * - Internal (10500)
   *
   * @generated from rpc domain.AccountService.GetRegistrationInfo
   */
  getRegistrationInfo: {
    methodKind: "unary";
    input: typeof GetRegistrationInfoRequestSchema;
    output: typeof GetRegistrationInfoResponseSchema;
  },
  /**
   * - EmailTaken (20100): email address taken, backup code is available
   * - InvalidEmail (20101): invalid email address
   * - EmailInviteNotActive (20106): email belongs to an org profile that has no active email invite
   * - EmailTakenNotRecoverable (20107): email address taken, no backup code available
   * - AuthenticatorExists (40470): an authenticator with the provided id already exists
   * - ProfileNotFound (70400): profile not found, or is not an organization profile
   * - MissingProfileAuthenticatorLock (70410)
   * - InvalidProfileSignature (70420)
   * - NotAllowedForProfile (70433): service profile must be registered as service user
   * - WebathnDataError (1000401): there is a parsing error with the webauthn response
   * - WebauthnRequestNotFound (1000402)
   * - WebauthnValidateError (1000400): there is a cryptographic error with the webauthn response
   * - WebauthnInvalidTransport (1000403): tried to register with passkey
   * - StartCodeInvalid (70430)
   * - StartCodeBlocked (70431)
   * - StartCodeMissing (70432)
   * - BrowserManagedDeviceTokenInvalid (30470): organization restricts logins to managed devices
   * - Internal (10500): internal server error
   * - BadRequest (10400): no authenticators sent or authenticator id/type mismatch
   *
   * @generated from rpc domain.AccountService.CreateWithProfile
   */
  createWithProfile: {
    methodKind: "unary";
    input: typeof CreateAccountWithProfileRequestSchema;
    output: typeof CreateAccountWithProfileResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100): missing credentials
   * - InvalidCredentials (30420): the credentials provided are invalid (e.g. session was deleted)
   * - InvalidLocale (20105): invalid locale
   * - MalformedUserClientSettings (20108): user settings are not valid json
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.AccountService.Update
   */
  update: {
    methodKind: "unary";
    input: typeof UpdateAccountRequestSchema;
    output: typeof UpdateAccountResponseSchema;
  },
  /**
   * errors:
   * - UserNotFound (20400)
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.AccountService.CreateReferrer
   */
  createReferrer: {
    methodKind: "unary";
    input: typeof CreateReferrerRequestSchema;
    output: typeof CreateReferrerResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100): missing credentials
   * - InvalidCredentials (30420): the credentials provided are invalid (e.g. session was deleted)
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.AccountService.AddAchievements
   */
  addAchievements: {
    methodKind: "unary";
    input: typeof AddAchievementsRequestSchema;
    output: typeof AddAchievementsResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100): missing credentials
   * - InvalidCredentials (30420): the credentials provided are invalid (e.g. session was deleted)
   * - InvalidEmail (20101): invalid email address
   * - UserNotFound (20400): user not found
   * - ProfileNotFound (70400): profile not found
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.AccountService.List
   */
  list: {
    methodKind: "unary";
    input: typeof ListAccountsRequestSchema;
    output: typeof ListAccountsResponseSchema;
  },
  /**
   * errors:
   * - InvalidCredentials (30420): the credentials provided are invalid (e.g. session was deleted)
   * - InvalidEmail (20101): invalid email address (only if fail_fast is set)
   * - UserNotFound (20400): user not found (only if fail_fast is set)
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.AccountService.ResolveEmails
   */
  resolveEmails: {
    methodKind: "unary";
    input: typeof ResolveEmailsRequestSchema;
    output: typeof ResolveEmailsResponseSchema;
  },
  /**
   * no errors, this is a static endpoint
   *
   * @generated from rpc domain.AccountService.GetPaddleConfig
   */
  getPaddleConfig: {
    methodKind: "unary";
    input: typeof GetPaddleConfigRequestSchema;
    output: typeof GetPaddleConfigResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100): missing credentials
   * - InvalidCredentials (30420): the credentials provided are invalid (e.g. session was deleted)
   * - OrganizationMissingAdmin (60410): user is last admin in an organization with other users
   * - UserNotFound (20400): user not found (this should never happen)
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.AccountService.Delete
   */
  delete: {
    methodKind: "unary";
    input: typeof DeleteAccountRequestSchema;
    output: typeof DeleteAccountResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_account_service, 0);

